import { useLocation, useNavigate } from "react-router-dom";

type Updater = Record<string, string | number | null | undefined>;
type Options = { replace?: boolean; preserveHash?: boolean };

export const useQueryNavigator = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const buildUrl = (base: string, qs: string, hash: string) =>
    `${qs ? `${base}${base.includes("?") ? "&" : "?"}${qs}` : base}${hash}`;

  return (
    basePath: string,
    keyOrUpdates: string | Updater,
    value?: string | number | null | undefined,
    opts?: Options
  ) => {
    const params = new URLSearchParams(location.search);

    const apply = (k: string, v: any) => {
      if (v === null || v === undefined || v === "") params.delete(k);
      else params.set(k, String(v));
    };

    if (typeof keyOrUpdates === "string") {
      apply(keyOrUpdates, value);
    } else {
      Object.entries(keyOrUpdates).forEach(([k, v]) => apply(k, v));
    }

    const qs = params.toString();
    const hash = opts?.preserveHash ? location.hash : "";
    navigate(buildUrl(basePath, qs, hash), { replace: opts?.replace });
  };
};
